import { render, staticRenderFns } from "./navigateUp.vue?vue&type=template&id=2277df25&scoped=true&"
import script from "./navigateUp.vue?vue&type=script&lang=js&"
export * from "./navigateUp.vue?vue&type=script&lang=js&"
import style0 from "./navigateUp.vue?vue&type=style&index=0&id=2277df25&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2277df25",
  null
  
)

export default component.exports